import withHandler from "recompose/withHandlers";
import compose from "recompose/compose";
import BreadCrumbItem from "./BreadCrumbItem";
import withTextOverlay from "./withTextOverlay";

const enhance = compose(
  withTextOverlay,
  withHandler({
    onClick: (props) => () => {
      props.setActivePage(props.pageNumber);
    },
  })
);

export default enhance(BreadCrumbItem);
